import { Router } from '@okapi/router-react';
import React from 'react';
import { StoreContext } from 'storeon/react';
import { Baseline } from 'common/components';
import { KitchenStyles } from 'landings/kitchen-styles';
import { RemoteProps } from './widgets-types';

export const KitchenStylesRemote: React.FC<RemoteProps> = ({ router, store }) => (
  /* @ts-expect-error: Router typecheck error */
  <Router router={router}>
    <Baseline>
      <StoreContext.Provider value={store}>
        <KitchenStyles />
      </StoreContext.Provider>
    </Baseline>
  </Router>
);
